import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import withStyles from '@material-ui/styles/withStyles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';

import axiosInstance, { getEventId, WEB_API, EVENT_IMG, EVENT_ID, EVENT_CODE, dDayCount } from '../constatns';
import Topbar from './Topbar';
import Footer from './Footer';
import Container from '../components/Div/Container';
import MainSpeakersComponent from './MainSpeakersComponent';
import swal from 'sweetalert';
import { Typography } from '@material-ui/core';
import './Main.css';

import EventDialog from '../components/EventDialog';
import { Backdrop } from '@mui/material';
import { withCookies, Cookies } from 'react-cookie';
// import Slider from 'react-slick';

const moment = require('moment');

// 아이콘은 모두 표시하되 오픈 전까지는
const middleMenus = [
  { img: 'ic_ksprs', text: 'KSPRS', path: '/main' },
  // { img: 'ic_program', text: 'Program', path: '/program/list' },
  { img: 'ic_program', text: 'Program', path: '/program/list' },
  { img: 'ic_freepaper', text: 'Free Paper', path: '/paper/guide' },
  { img: 'ic_registration', text: 'Registration', path: '/registration/guide' },
  { img: 'ic_sponsorship', text: 'Sponsorship', path: '/sponsor/information' },
  { img: 'ic_info', text: 'General Information', path: '/info/venue' },
  // { img: 'ic_registration', text: 'Registration', path: '/registration/guide' },
  // { img: 'ic_sponsorship', text: 'Sponsorship', path: '/sponsor/information' },
];

const keyDates = [
  { titleEn: 'Deadline for Pre-Registration', deadline: '2022-10-31' },
  { titleEn: 'Deadline for Invited Speaker Abstract Submission', deadline: '2022-10-21' },
  { titleEn: 'Deadline for Early-Bird Registration ', deadline: '2022-09-16', prevDeadline: '2022-08-31' },
  { titleEn: 'Notification of Abstract Acceptance', deadline: '2022-09-8', prevDeadline: '2022-08-31' },
  { titleEn: 'Deadline for Free Paper Submission', deadline: '2022-08-26', prevDeadline: '2022-08-12' },
];

const styles = (theme) => ({
  menus: {
    padding: '30px 0',
    backgroundColor: '#fff',
    '& span': { color: '#4c4c4c', fontWeight: 'bold' },
    '& img:first-child': {
      display: 'block',
      margin: '0 auto',
    },
    '& img:last-child': {
      display: 'none',
    },
    '&:hover': {
      // backgroundColor: theme.palette.primary.main,
      // '& span': { color: '#fff' },
      '& span': { color: theme.palette.primary.main, fontWeight: 'bold' },
      '& img:first-child': {
        display: 'none',
      },
      '& img:last-child': {
        display: 'block',
        margin: '0 auto',
        // backgroundColor: '#e9e96a',
      },
    },
  },
  gridInner: {
    height: '100%',
    padding: '10px',
    boxSizing: 'border-box',
    borderTop: `2px solid ${theme.palette.primary.main}`,
    borderBottom: `2px solid #eee`,
  },
  title2: {
    color: theme.palette.primary.main,
    fontSize: '1.4em',

    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingBottom: '10px',
    '& p': {
      fontWeight: 'bold',
    },
  },
  list: { padding: '10px 0', borderTop: '1px solid red' },
  speakerDiv: {
    width: 'calc(100% / 3)',
    '& > div:first-child': {
      textAlign: 'center',
      fontWeight: 'bold',
      fontSize: '1.4em',
      paddingBottom: '1em',
    },
    '& > div:not(:first-child)': {
      display: 'flex',
      flexDirection: 'row',
    },
    '& img': {
      maxWidth: '147px',
    },
  },
  vodIframe: {
    width: '120%',
    height: '100%',
    transform: `scaleX(0.834)`,
    position: 'absolute',
    top: '0',
    left: '-9.8%',
    // border: `1px solid ${theme.palette.primary.main}`,

    // [theme.breakpoints.up('xl')]: {
    //   transform: `scale(1, 1.2)`,
    // },

    // [theme.breakpoints.down('lg')]: {
    //   transform: `scale(1, 1.4)`,
    // },
  },
  goWebinar: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    alignItems: 'center',
    borderTop: '2px solid #194579',
    borderBottom: '2px solid #eee',
    '& >a': {
      width: '100%',
      height: '100%',
      '& >img': {
        width: '100%',
        height: '100%',
        // objectFit: 'cover',
      },
    },
  },
});

class Main extends Component {
  constructor(props) {
    super(props);
    this.state = {
      eventDialog: true,
    };
    this.goToPage = this.goToPage.bind(this);
  }

  componentDidMount() {
    this.getBbsList();
    if (sessionStorage.getItem('EVENT')) this.getKeyDates();
    else {
      axiosInstance
        .get(`${WEB_API}/event/info?eventId=${getEventId()}&code=${encodeURIComponent(EVENT_CODE)}`, {
          headers: { Pragma: 'no-cache' },
        })
        .then((response) => {
          if (response.data.Item) {
            sessionStorage.setItem('EVENT_ID', getEventId());
            sessionStorage.setItem('EVENT', JSON.stringify(response.data.Item));
            this.getKeyDates();
          }
        });
    }
    // 팝업 체크
    if (this.props.cookies.get('popupCookie')) {
      this.setState({ eventDialog: false });
    }
  }

  goToPage(_move) {
    this.props.history.push(_move);
  }

  getBbsList() {
    axiosInstance
      .get(`${WEB_API}/bbs/list?eventId=${EVENT_ID}`)
      .then((response) => {
        // convert string to Number
        response.data.Items.forEach((item) => {
          if (typeof item.sortOrder === 'string') {
            item.sortOrder = Number(item.sortOrder);
          }
        });
        response.data.Items.sort((a, b) => {
          return Number(b.sortOrder) - Number(a.sortOrder);
        });
        this.setState({ bbsData: response.data.Items.slice(0, 5) }, () => {
          this.renderBbs(this.state.bbsData);
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  getKeyDates() {
    const EVT = JSON.parse(sessionStorage.getItem('EVENT'));
    let buff = [{}, {}];
    // console.log(EVT);

    for (const [key, value] of Object.entries(EVT)) {
      // if (key)
      // //   if (key.indexOf('abstractAcceptance') !== -1 && value) {
      // //     if (key.indexOf('Title') !== -1) buff[0][`titleEn`] = value;
      // //     else buff[0][`deadline`] = value;
      // //   }
      // // if (key.indexOf('paperDeadline') !== -1 && value) {
      // //   if (key.indexOf('Title') !== -1) buff[1][`titleEn`] = value;
      // //   else buff[1][`deadline`] = value;
      // // }
      // // if (key.indexOf('regDeadline') !== -1 && key.indexOf('regDeadline2') === -1 && value) {
      // //   if (key.indexOf('Title') !== -1) buff[2][`titleEn`] = value;
      // //   else buff[2][`deadline`] = value;
      // // }
      if (key.indexOf('regDeadline2') !== -1 && value) {
        if (key.indexOf('Title') !== -1) buff[0][`titleEn`] = value;
        else buff[0][`deadline`] = value;
      }
    }
    buff[1]['titleEn'] = 'PRS KOREA 2021';
    buff[1]['deadline'] = '2021-11-12T00:00';

    this.setState({ keyDates: buff });
  }

  renderKeyDates = () => {
    // return this.state.keyDates
    return keyDates
      .sort((a, b) => {
        const aDead = dDayCount(a.deadline);
        const bDead = dDayCount(b.deadline);
        if (aDead < bDead) return -1;
        if (aDead > bDead) return 1;
        return 0;
      })
      .map((data, idx) => {
        return (
          <Grid
            container
            style={{
              padding: '10px 0',
              borderTop: '1px solid #f8f8f8',
              // color: '#666',
            }}
            key={`key-dates-${idx}`}
          >
            <Grid
              item
              xs={8}
              style={{
                // color: '#666',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-around',
              }}

              // onClick={() => this.setDetail(data)}
            >
              <b style={{ fontSize: '1.2em', fontWeight: 'normal' }}>{data.titleEn}</b>

              {data.prevDeadline && (
                <del>
                  <p className={`d_day_text_${idx}`} style={{ fontSize: '1.2em', fontWeight: 'bold', color: 'grey' }}>
                    {moment(data.prevDeadline).tz('Asia/Seoul').format('MMMM D (ddd), YYYY')}
                  </p>
                </del>
              )}

              <p className={`d_day_text_${idx}`} style={{ fontSize: '1.3em', fontWeight: 'bold' }}>
                {moment(data.deadline).tz('Asia/Seoul').format('MMMM D (ddd), YYYY')}
              </p>
            </Grid>
            <Grid item xs={1} />
            <Grid container justifyContent="center" alignItems="center" item xs={3}>
              <Grid
                container
                justifyContent="center"
                alignItems="center"
                className={`d_day_grid_${idx}`}
                style={{
                  borderRadius: '8px',

                  color: '#fff',
                  height: '60px',
                }}
              >
                <Grid container justifyContent="center" style={{ fontSize: 'large', height: '30px' }}>
                  D-Day
                </Grid>
                {/* <Grid container justifyContent="flex-end" item xs={2}>
                <Typography style={{ fontSize: '18px', fontWeight: 'bold' }}>D&nbsp;</Typography>
              </Grid>
              <Grid container justifyContent="flex-start" item xs={8}>
                <Typography style={{ fontSize: '18px', fontWeight: 'bold' }}>
                  {dDayCount(data.deadline) > 0 ? '-' : '+'}
                  {dDayCount(data.deadline) > 0
                    ? dDayCount(data.deadline)
                    : dDayCount(data.deadline) < 0
                    ? Number(dDayCount(data.deadline).toString().replace(/-/g, '')) + 1
                    : dDayCount(data.deadline).toString().replace(/-/g, '')}
                </Typography>
              </Grid> */}
                <Grid
                  container
                  justifyContent="center"
                  style={{ height: '30px', border: '1px solid', backgroundColor: '#f5f5f5' }}
                  className={`d_day_grid_${idx}`}
                >
                  <Typography style={{ fontSize: 'large', color: '#7e7e7e' }}>
                    {dDayCount(data.deadline) > 0 ? '-' : '+'}
                    {
                      dDayCount(data.deadline) > 0
                        ? // 20220810 D DAY -Day 하루씩 작게 계산되는 부분 수정
                          dDayCount(data.deadline) + 1
                        : dDayCount(data.deadline) < 0
                        ? Number(dDayCount(data.deadline).toString().replace(/-/g, ''))
                        : 0
                      // dDayCount(data.deadline).toString().replace(/-/g, '')
                    }
                  </Typography>
                </Grid>
                {/* <div
                style={{
                  backgroundColor: this.props.theme.palette.secondary.main,
                  borderRadius: '3px',
                  textAlign: 'center',
                  color: '#fff',
                }}
              >
                <p style={{ padding: '3px 0' }}>D-DAY</p>
                <p style={{ padding: '3px 0', backgroundColor: '#f5f5f5', fontWeight: 'bold', color: '#7e7e7e' }}>
                  {dDayCount(data.deadline) > 0 ? '-' : '+'}
                  {dDayCount(data.deadline) > 0
                    ? dDayCount(data.deadline)
                    : dDayCount(data.deadline) < 0
                    ? Number(dDayCount(data.deadline).toString().replace(/-/g, '')) + 1
                    : dDayCount(data.deadline).toString().replace(/-/g, '')}
                </p>
              </div> */}
              </Grid>
            </Grid>
          </Grid>
        );
      });
  };

  renderBbs = () => {
    return this.state.bbsData.map((data, idx) => {
      if (typeof data.sortOrder === 'number') {
        return (
          <Grid
            container
            style={{ padding: '10px 0', borderTop: '1px solid #f8f8f8', cursor: 'pointer', color: '#666', fontSize: '1.2em' }}
            key={`bbs-data-${idx}`}
          >
            <Grid item xs={9} style={{ color: '#666' }} onClick={() => this.setDetail(data)}>
              {data.bbsTitle}
            </Grid>
            <Grid
              item
              xs={3}
              style={{ textAlign: 'right', color: '#aaa', display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}
            >
              {moment(Number(data.createdAt)).format('YYYY-MM-DD')}
            </Grid>
          </Grid>
        );
      }
    });
  };

  setDetail = (newVal) => {
    axiosInstance
      .get(`${WEB_API}/bbs/info?eventId=${EVENT_ID}&bbsId=${newVal.id}`) //조회수 +1
      .then((response) => {
        this.setState({ notiItems: newVal }, () => {
          this.props.history.push({
            pathname: '/bbs_detail',
            search: '?' + newVal.id,
          });
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  mainMenuClick(_path) {
    // console.log(_path);
    if (_path === '/main') {
      window.open('https://www.plasticsurgery.or.kr/');
    } else {
      if (_path == false) {
        swal('', 'To be updated', 'info');
      } else {
        this.props.history.push(_path);
      }
    }
  }

  render() {
    const { classes } = this.props;
    // dDay.diff(today, 'days');

    const renderMenus = (datas) =>
      datas.map((data, idx) => {
        return (
          <Grid
            key={'mn-' + idx}
            item
            container
            justifyContent="center"
            alignItems="center"
            className={classes.menus}
            style={{ width: '15%', cursor: 'pointer' }}
            onClick={() => this.mainMenuClick(data.path)}
          >
            <p style={{ width: '100%', textAlign: 'center', margin: 10 }}>
              <img src={`${EVENT_IMG}/ic/${data.img}.png`} alt={'img_' + data.img} />
              <img src={`${EVENT_IMG}/ic/${data.img}-hover.png`} alt={'imgHover_' + data.img} />
            </p>
            <span style={{ fontSize: '1.5em', fontWeight: 500, fontFamily: 'Roboto' }}>{data.text}</span>
          </Grid>
        );
      });

    return (
      <div>
        <CssBaseline />
        <Topbar MIdx={0} SIdx={0} />
        <Container>
          <Grid container justifyContent={'center'} style={{ width: '85vw', margin: '0 auto' }}>
            <Grid container style={{ padding: '8px 0 20px' }}>
              {renderMenus(middleMenus)}
            </Grid>
            <Grid container spacing={3} style={{ width: '100%', marginBottom: '30px' }}>
              <Grid item xs={4} style={{ padding: '0 12px' }}>
                <div className={classes.gridInner}>
                  <div className={classes.title2}>
                    <p>Key Dates</p>
                  </div>
                  <div>{this.state.keyDates ? this.renderKeyDates() : null}</div>
                </div>
                {/* <div className={classes.goWebinar}>
                  <a href={`https://prskorea2021.webconference.kr/#/`} target="_blank">
                    <img src="/images/PRS2021/goWebinar.png" alt="PRS2021" />
                  </a>
                </div> */}
              </Grid>
              <Grid item xs={4} style={{ padding: '0 12px' }}>
                <div className={classes.gridInner}>
                  <div className={classes.title2}>
                    <p>News &amp; Notice</p>{' '}
                    <span style={{ color: '#bbb', fontSize: '1em', cursor: 'pointer' }} onClick={() => this.props.history.push('/bbs')}>
                      +&nbsp;&nbsp;More
                    </span>
                  </div>
                  <div>{this.state.bbsData ? this.renderBbs() : null}</div>
                </div>
              </Grid>

              <Grid item xs={4} style={{ padding: '0 12px' }}>
                <div className={classes.gridInner}>
                  <div className={classes.title2}>
                    <p>About Korea</p>
                  </div>
                  <div style={{ width: '100%', height: '100%' }}>
                    <div style={{ maxWidth: '650px' }}>
                      <div
                        style={{
                          height: 0,
                          /*  padding top은 부모 요소의 가로 요소에 영향을 받는다  */
                          /*  height는 반응형이 안되고 크기를 픽스해버리는 것임  */
                          paddingTop: '56.25%',
                          position: 'relative',
                        }}
                      >
                        <iframe
                          title={'welcomePlayer'}
                          id="player"
                          src={'https://player.vimeo.com/video/720114539'}
                          frameBorder="0"
                          // allow="accelerometer; autoplay; encrypted-media;"
                          allow="accelerometer; encrypted-media;"
                          allowFullScreen={true}
                          style={{
                            background: 'black',
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                          }}
                          // className={classes.vodIframe}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </Grid>
            </Grid>
            <div
              style={{
                // backgroundImage: `url('${EVENT_IMG}/speaker_bg.png')`,
                // backgroundRepeat: 'no-repeat',
                // borderRadius: '5px',
                height: '100%',
                width: '100%',
                paddingBottom: '50px',
              }}
            >
              <MainSpeakersComponent />
            </div>
          </Grid>
        </Container>
        <Footer />

        <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={this.state.eventDialog}>
          <EventDialog
            onClose={() => {
              this.setState({ eventDialog: false });
            }}
            goToPage={(e) => {
              this.props.history.push(e);
            }}
          />
        </Backdrop>
      </div>
    );
  }
}

export default withRouter(withCookies(withStyles(styles, { withTheme: true })(Main)));
